import useGetColors from "../../utils/colors";
import t from "../../theme";
import { doodleBackgroundImage } from "../../utils/doodlePattern";

const logoWhiteOutline =
  "drop-shadow(0 0.45px 0.5px rgba(255,255,255,0.95)) " +
  "drop-shadow(0 0.8px 1.5px rgba(255,255,255,0.72)) " +
  "drop-shadow(0.7px 0 0 rgba(255,255,255,0.92)) " +
  "drop-shadow(-0.7px 0 0 rgba(255,255,255,0.92)) " +
  "drop-shadow(0 0.95px 0 rgba(255,255,255,0.92)) " +
  "drop-shadow(0 -0.35px 0 rgba(255,255,255,0.7)) " +
  "drop-shadow(0.6px 0.85px 0 rgba(255,255,255,0.88)) " +
  "drop-shadow(-0.6px 0.85px 0 rgba(255,255,255,0.88)) " +
  "drop-shadow(0.45px -0.35px 0 rgba(255,255,255,0.68)) " +
  "drop-shadow(-0.45px -0.35px 0 rgba(255,255,255,0.68))";

export const useGetAppBarStyles = () => {
  const { appBarColors } = useGetColors();

  return {
    header: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      padding: "0 45px",
      backgroundColor: "#2e7d32",
      backgroundImage: doodleBackgroundImage,
      backgroundSize: "300px 300px",
      backgroundRepeat: "repeat",
      position: "sticky",
      top: "0",
      alignItems: "center",
      minHeight: "60px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.12)",
      zIndex: 10,
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      transition: t.transition.smooth,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      "@media (max-width: 768px)": {
        padding: "0 15px",
        minHeight: "56px",
      },
    },
    logo: {
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      verticalAlign: "middle",
      marginTop: "-4px",
      filter: logoWhiteOutline,
      "&:hover": {},
      "@media (max-width: 425px)": {
        width: "68px",
      },
    },
    logom: {
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      verticalAlign: "middle",
      marginTop: "-4px",
      filter: logoWhiteOutline,
      "&:hover": {},
      "@media (max-width: 425px)": {
        width: "82px",
        height: "auto",
      },
    },
    mobileLogos: {
      display: "flex",
      alignItems: "center",
      gap: 5,
      flexWrap: "nowrap",
      flexShrink: 0,
      "& a": {
        display: "inline-flex",
        alignItems: "center",
      },
      "@media (max-width: 425px)": {
        "& a img": {
          width: "58px",
          height: "auto",
        },
      },
    },
    mobilelogo: {
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      verticalAlign: "middle",
      marginTop: "-4px",
      filter: logoWhiteOutline,
      "&:hover": {},
      "@media (max-width: 425px)": {
        width: "36%",
      },
    },
    Bingologo: {
      cursor: "pointer",
      paddingLeft: "20px",
      width: "100%",
      filter: logoWhiteOutline,
    },
    // "Home" header: same green/doodle brand chrome as every other page's
    // `header` above — only the layout differs (logo + icon row on one
    // line, the location pill on its own line below, matching the native
    // app's structure), not the color scheme.
    homeHeader: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: "10px 20px 10px",
      backgroundColor: "#2e7d32",
      backgroundImage: doodleBackgroundImage,
      backgroundSize: "300px 300px",
      backgroundRepeat: "repeat",
      position: "sticky",
      top: "0",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.12)",
      zIndex: 10,
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    },
    homeHeaderRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
    },
    homeLocationRow: {
      marginTop: 10,
    },
    homeLogo: {
      height: 32,
      cursor: "pointer",
      filter: logoWhiteOutline,
    },
    homeNav: {
      display: "flex",
      alignItems: "center",
      gap: "2px",
      flexShrink: 0,
      "& .MuiIconButton-root": {
        padding: 4,
        color: "#ffffff",
      },
      "& .MuiAvatar-root": {
        border: "2px solid rgba(255, 255, 255, 0.4)",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
      },
    },
    nav: {
      marginLeft: "auto",
      display: "flex",
      gap: "0.5rem",
      justifyContent: "flex-end",
      alignItems: "center",
      "& .MuiIconButton-root": {
        transition: t.transition.smooth,
        borderRadius: t.radius.md,
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.12)",
          transform: "translateY(-2px)",
        },
      },
      "& .MuiBadge-badge": {
        fontWeight: 600,
        fontSize: "0.65rem",
        minWidth: "18px",
        height: "18px",
        padding: "0 4px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      },
      "& .MuiAvatar-root": {
        cursor: "pointer",
        transition: t.transition.smooth,
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
        border: "2px solid rgba(255, 255, 255, 0.4)",
        "&:hover": {
          transform: "scale(1.1)",
          boxShadow: "0 4px 12px rgba(84, 172, 52, 0.4)",
        },
      },
      "@media (max-width: 768px)": {
        gap: "2px",
        "& .MuiIconButton-root": {
          padding: 4,
        },
        "& .MuiAvatar-root": {
          width: 30,
          height: 30,
          padding: 2,
          fontSize: 13,
        },
      },
    },
  };
};
